import { useEffect, useState } from 'react'

import FolderService from 'services/folder.service'

import { FolderTreeResponse } from 'types/folders'

import LineLoader from 'components/elements/LineLoader'
import Accordion from 'components/elements/Accordion'

import styles from './folderTree.module.scss'

type Props = {
  selectedFolder: number | undefined | null
  setFolderId: (id: number) => void
}

const FolderTree = ({ selectedFolder, setFolderId }: Props) => {
  const [data, setData] = useState<FolderTreeResponse | null>(null)
  const [loading, setLoading] = useState(false)

  const fetchFolderTree = () => {
    setLoading(true)

    return FolderService.folderTree()
      .then(data => {
        const activeRoot = { ...data, active: true, toggled: data.children && data.children.length < 4 }

        setData(activeRoot)
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchFolderTree()
  }, [])

  if (loading) return <LineLoader />
  if (data === null) return <div>Unable to fetch folder tree</div>

  return (
    <div className={styles.container}>
      <FolderNode selectedFolder={selectedFolder} folderNode={data} onSetFolderId={setFolderId} />
    </div>
  )
}

export default FolderTree

const FolderNode = ({
  selectedFolder,
  onSetFolderId,
  folderNode,
  className = '',
}: {
  selectedFolder: number | undefined | null
  onSetFolderId: (id: number) => void
  folderNode: FolderTreeResponse
  className?: string
}) => (
  <Accordion
    label={folderNode.name}
    className={`${className} ${selectedFolder === folderNode.id ? styles.selected : ''}`}
    onChange={() => onSetFolderId(folderNode.id)}>
    {folderNode.children?.map(childNode => (
      <div key={childNode.id} className={styles.options}>
        {childNode.children?.length && (
          <FolderNode
            selectedFolder={selectedFolder}
            folderNode={childNode}
            onSetFolderId={onSetFolderId}
            className={styles.levelBumpIn}
          />
        )}

        {!childNode.children?.length && (
          <button
            className={`${styles.noChildren} ${styles.levelBumpIn} ${selectedFolder === childNode.id ? styles.selected : ''}`}
            onClick={() => onSetFolderId(childNode.id)}>
            {childNode.name}
          </button>
        )}
      </div>
    ))}
  </Accordion>
)
